import { useEffect } from "react";
import { site } from "@/content/site";

/** Sets the page title and description for the current route. */
export function useDocumentMeta(title: string | null, description: string = site.description) {
  useEffect(() => {
    document.title = title ? `${title} · ${site.name}` : `${site.name} — ${site.descriptor}`;
    document.querySelector('meta[name="description"]')?.setAttribute("content", description);
  }, [title, description]);
}
